module.exports = __webpack_public_path__ + "img/schliessen.b6d43ff5.svg";